import { createFileRoute, notFound } from "@tanstack/react-router";

import { SITE_NAME } from "@/lib/site";

/** Catch-all so unknown paths throw a 404 instead of matching nothing silently. */
export const Route = createFileRoute("/$")({
  head: () => ({
    meta: [
      { title: `Page not found | ${SITE_NAME}` },
      { name: "robots", content: "noindex, follow" },
      { name: "description", content: "This page isn't here. Browse handmade doll clothes or head home." },
    ],
  }),
  beforeLoad: () => {
    throw notFound();
  },
});
